export default {
  TABLET_SIZE: 980,
  DESKTOP_SIZE: 1280,
  DESKTOP_ZOOM_SIZE: 1200,
};
